import { Icon } from '@ps/isp-web-component-library';
import { BetBuilder } from '@ps/isp-web-component-library/icons/BetBuilder';
import { Multiples } from '@ps/isp-web-component-library/icons/Multiples';
import type { MultipleBetType, SgmData } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { SgmEventAndLegCount } from '@swf/layouts/SportsLayout/components/BetSlip/components/SgmEventAndLegCount/SgmEventAndLegCount';
import { BetPriceOdds } from '@swf/sports/components/BetPriceOdds/BetPriceOdds';
import type { BetPriceOdds as BetPrice } from '@swf/sports/types/odds';
import { getMultipleName } from '@swf/sports/utils/getMultipleName';

import { TXTWCL_EW } from './Title.messages.json';
import styles from './Title.scss';

interface Props {
  type?: MultipleBetType;
  numberOfLines: number;
  betPrice?: BetPrice;
  isEachWaySelected?: boolean;
  isSgm?: boolean;
  sgmData?: SgmData[];
}

const Title: React.FC<Props> = ({
  type,
  numberOfLines,
  betPrice,
  isSgm,
  isEachWaySelected,
  sgmData
}) => (
  <div className={classNames(styles.wrapper)}>
    <h3 className={styles.title}>
      <div className={classNames({ [styles.iconWrapper]: isSgm })}>
        <Icon icon={isSgm ? BetBuilder : Multiples} size="x1" data-testid="sports-icon" />
      </div>
      <div>
        {getMultipleName({
          betType: type,
          numberOfLines,
          isSgm
        })}{' '}
        {numberOfLines === 1 && betPrice ? (
          <>
            @ <BetPriceOdds {...betPrice} />
          </>
        ) : null}
        {isEachWaySelected ? (
          <>
            {' '}
            <Translation {...TXTWCL_EW} />{' '}
          </>
        ) : null}
        {isSgm && sgmData && <SgmEventAndLegCount sgmData={sgmData} />}
      </div>
    </h3>
  </div>
);

export default Title;
